module.exports = __webpack_public_path__ + "static/media/aboutus-2.a8a726f4.png";